import React from 'react';
import { styled } from 'linaria/react';
import { Typography } from 'fronton-react';
import { NotFoundImg } from './not-found-img';
import { breakpoints } from '../../../media';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 40px;
	padding-block: 80px;
	margin-block: 48px;
	max-width: 500px;
	align-self: center;

	& h3 {
		text-align: center;
	}

	${breakpoints.to.largeDesktop} {
		margin-top: 32px;
	}
	${breakpoints.to.desktop} {
		margin-block: 32px;
		padding-block: 40px;
	}
	${breakpoints.to.tablet} {
		margin-block: 24px;
		padding-block: 40px;
		padding-inline: 16px;
	}
`;

export const NotFound = ({ description }) => (
	<Wrapper>
		<NotFoundImg />
		<Typography variant="h3" as="h3">
			{description}
		</Typography>
	</Wrapper>
);
